import * as React from 'react';
import * as ReactDOMServer from 'react-dom/server';

export const buildPrintHtml = (buildPrintElements: () => React.ReactNode, buildHeadElements?: () => React.ReactNode) => {
  return `<html>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <title>Print</title>
    ${buildHeadElements === undefined ? '' : ReactDOMServer.renderToStaticMarkup(<>{buildHeadElements()}</>)}
  </head>
  <body>
    ${ReactDOMServer.renderToStaticMarkup(<div>{buildPrintElements()}</div>)}
  </body>
</html>`
};



// WEBPACK FOOTER //
// ./src/components/print-util.tsx